// extracted by mini-css-extract-plugin
module.exports = {"PowerStation":"PowerStation_PowerStation__jL9Ny"};